import { Organization, OrganizationParams } from "@/store/dictionaries/organizations";
import { Entity } from "@/store/history/history";
import { useHistoryStore } from "@/store/history/history";

export function areOrganizationFieldsValid(org: Organization): boolean {

    if (!org.name || !org.tenant) {
        return false;
    }
    for (const department of org.departments) {
        if (!department.name) {
            return false;
        }
        if (department.roles)
            for (const role of department.roles) {
                if (!role.name) {
                    return false;
                }
            }
    }

    return true;
}

export function setOrganizationsParamsByFilter(params: OrganizationParams, settings: TableSettings) {
    if (settings.orderField) {
        params.order_by = settings.orderField;
    } else {
        params.order_by = '-mtime';
    }

    if (settings.commonFilter) {
        params.name__ilike = settings.commonFilter;
    }

    if (Object.keys(settings.filter).length > 0 && typeof settings.filter.include_demo === "boolean") {
        params.include_demo = settings.filter.include_demo;
    }
}

export function getEntitiesByOrganization(org: any): Entity[] {
    const entities: Entity[] = [];
    entities.push({
        entity: "organizations",
        entity_ids: [org.id],
    });
    const deps: number[] = [];
    const roles: number[] = [];
    org.departments.forEach((dep: any) => {
        deps.push(dep.id);
        dep.roles.forEach((role: any) => {
            roles.push(role.id);
        });
    });
    entities.push({
        entity: "departments",
        entity_ids: deps,
    });
    entities.push({
        entity: "roles",
        entity_ids: roles,
    });
    return entities;
}

export function getHistories(resp: any) {
    const mapTransactions: Map<number, object> = new Map();
    const historyStore = useHistoryStore();
    if (resp) {
        resp.forEach((e: any) => {
            for (let i = 0; i < e.histories.length; i++) {
                let obj = {} as any;
                if (mapTransactions.has(e.histories[i].transaction_id)) {
                    obj = mapTransactions.get(e.histories[i].transaction_id);
                } else {
                    obj = {
                        operation_type: e.histories[i].operation_type,
                        changed_at: e.histories[i].changed_at,
                        changed_by: e.histories[i].changed_by,
                        changes: [],
                    };
                }
                for (const key in e.histories[i].changes) {
                    if (!historyStore.excludedFields.includes(key))
                        obj.changes.push({
                            field: ` ${historyStore.fieldsMap.get(key) || key
                                } (${historyStore.fieldsMap.get(e.id.entity)})`,
                            new: e.histories[i].changes[key].new,
                            old: e.histories[i].changes[key].old,
                        });
                }
                mapTransactions.set(e.histories[i].transaction_id, obj);
            }
        });
    }
    const sortedValues = Array.from(mapTransactions.entries())
        .sort(([keyA], [keyB]) => keyA - keyB)
        .map(([, value]) => value);

    return sortedValues;
}

interface TableSettings {
    first: number;
    orderField: string;
    commonFilter: string;
    filter: FilterForm;
}

export interface FilterForm {
    include_demo?: boolean;
}

